import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HotelIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M4 6V18.2727H5.8V15.4225H18.2002V18H20.0002V11.5C20.0002 9.62223 18.478 8.1 16.6002 8.1H12.1002H11.2002V9V13.6225H5.8V6H4ZM18.2002 13.6225H13.0002V9.9H16.6002C17.4839 9.9 18.2002 10.6163 18.2002 11.5V13.6225ZM8.5001 12.3999C9.32853 12.3999 10.0001 11.7283 10.0001 10.8999C10.0001 10.0715 9.32853 9.3999 8.5001 9.3999C7.67167 9.3999 7.0001 10.0715 7.0001 10.8999C7.0001 11.7283 7.67167 12.3999 8.5001 12.3999Z"
      />
    </SvgIcon>
  );
});
